import { useState } from 'react';

import { faShieldCheck } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import type { ZuubPatientListItemV3 } from '@/@types/zuub/contracts';
import type { Appointment } from '@/react-query/useAppointments';
import { usePreferences } from '@/react-query/usePreferences';

import { InsuranceInfoSheet } from './InsuranceInfoSheet';
import { faShieldXmark } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';

interface InsuranceStatusIconAndSheetProps {
  appointment: Appointment;
  zuubInsurance?: ZuubPatientListItemV3;
}

export const InsuranceStatusIconAndSheet = ({
  appointment,
  zuubInsurance,
}: InsuranceStatusIconAndSheetProps) => {
  const { data: prefs } = usePreferences();
  const [isInsuranceSheetOpen, setIsInsuranceSheetOpen] = useState(false);
  const isInsuranceEligibilityEnabled = prefs?.isInsuranceEligibilityEnabled;

  const plans = zuubInsurance?.plans;
  const showIcon =
    isInsuranceEligibilityEnabled && plans && plans.length > 0;

  const variant: 'success' | 'error' | 'warning' | null = showIcon
    ? (() => {
        const hasSuccessWithBenefits = plans!.some(
          (p) =>
            p.statusType === 'success' &&
            p.remainingBenefits &&
            p.remainingBenefits > 0,
        );
        const allPlansError =
          plans!.length > 0 &&
          plans!.every((p) => p.statusType === 'error');
        return hasSuccessWithBenefits
          ? 'success'
          : allPlansError
            ? 'error'
            : 'warning';
      })()
    : null;

  const icon =
    variant === 'error'
      ? faShieldXmark
      : variant === 'success'
        ? faShieldCheck
        : variant === 'warning'
          ? faShieldHalved
          : null;
  const iconColor =
    variant === 'error'
      ? 'vai-text-red-600'
      : variant === 'success'
        ? 'vai-text-green-600'
        : variant === 'warning'
          ? 'vai-text-yellow-600'
          : '';

  return (
    <>
      {showIcon && icon && (
        <button
          type="button"
          className="vai-flex vai-cursor-pointer vai-bg-transparent vai-border-none vai-p-0"
          onClick={() => setIsInsuranceSheetOpen(true)}
        >
          <FontAwesomeIcon
            icon={icon}
            className={classNames(
              'vai-flex vai-items-center vai-justify-center vai-w-4 vai-h-4',
              iconColor,
            )}
          />
        </button>
      )}
      <InsuranceInfoSheet
        appointment={appointment}
        pmsPatientId={zuubInsurance?.pmsPatientId}
        open={isInsuranceSheetOpen}
        onOpenChange={setIsInsuranceSheetOpen}
      />
    </>
  );
};
